<template>
  <div class="page_main">
    <menu2 style="z-index: 999" page_name="项目开票申请" back_type="close" back_icon="md-close"></menu2>
    <div style="height: 40px"></div>

    <div class="head_div">
      <div class="project_name">项目名称：{{ project_info.project_name }}</div>
      <div class="head_div2">
        <div class="record_head" @click="teshu_import_show = true">
          <Icon type="ios-cloud-upload" style="margin-right: 3px" />
          特殊项目批量导入
        </div>
        <div class="record_head" @click="click_kaipiao_record">
          <Icon type="ios-archive" style="margin-right: 3px" size="22" />
          结算历史记录
        </div>
      </div>
    </div>

    <!-- <div style="height: 40px"></div> -->

    <div class="invoice_div top10">
      <div class="title">
        <div>
          <Icon type="ios-bookmark" size="18" color="#0466dd" />发票抬头(必填)
        </div>

        <div class="title_right">
          <div class="add_invoice_title2" @click="export_invoice_table">
            <Icon type="ios-cloud-download-outline" /> 导出抬头
          </div>
          <div class="add_invoice_title" @click="add_invoice">
            <Icon type="md-add-circle" /> 添加抬头
          </div>
        </div>
      </div>
      <div class="search_invoice_div">
        <Input search enter-button @on-enter="search_invoice_title_change" @on-search="search_invoice_title_change"
          size="small" v-model="search_invoice_title" placeholder="筛选抬头" style="width: 200px" />
        <div style="font-size: 13px;margin-left:10px;color:#333">提示：开票抬头如不可用，请联系财务调整</div>
      </div>
      <Table max-height="300" @on-selection-change="table_selection_change" size="small" :columns="invoice_columns"
        :data="invoice_list" ref="table_invoice">
        <template #email="{ row }">
          <span>{{ row.email ? row.email : "待完善" }}&nbsp;
            <Icon @click="click_update_email(row)" v-if="row.email == ''" size="18" class="create_email"
              type="ios-create" />
          </span>
        </template>
        <template #jindie_code="{ row }">
          <div v-if="row.jindie_code == ''" class="jindie_code_status_error">
            不可用
          </div>
          <div v-else class="jindie_code_status_success">
            可用
          </div>
        </template>
        <template #action="{ row }">
          <span @click="invoice_del_title(row)" class="del_invoice">删除</span>
        </template>
      </Table>
    </div>

    <div class="invoice_div">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />结算归属年月(必填)
          <span class="yewu_txt">（业务真实发生的所属期,例如：厂里8月份的数据，不管当前是9月、10月还是11月，归属年月还是按8月算）</span>
        </div>
      </div>
      <div class="jiesuan_select_div">
        <RadioGroup v-model="jiesuan_year_month_status">
          <Radio label="j1">
            <span class="jiesuan_txt">结算上个月{{ shangyue() }}</span>
          </Radio>
          <Radio label="j2">
            <span class="jiesuan_txt">结算本月{{ benyue() }}</span>
          </Radio>
          <Radio label="j3">
            <span class="jiesuan_txt">结算其他月份</span>
          </Radio>
        </RadioGroup>
        <DatePicker v-if="jiesuan_year_month_status == 'j3'" size="small" v-model="jiesuan_year_month" type="month"
          placeholder="选择月" style="width: 200px" />

        <!-- <div class="jiesuan_select" @click="click_jiesuan_month_btn(0)">结算上月</div>
        <div class="jiesuan_select" @click="click_jiesuan_month_btn(1)">结算本月</div>
        <div class="jiesuan_select">结算其他月</div>
        <DatePicker
          size="small"
          v-model="jiesuan_year_month"
          type="month"
          placeholder="选择月"
          style="width: 200px"
        /> -->
      </div>
    </div>

    <div class="invoice_div top10">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />结算说明/备注(必填)
        </div>
      </div>
      <div>
        <Input size="small" v-model="jiesuan_remarks" placeholder="请输入内容，如电子邮箱，x月代发福利，代发年终奖等等" style="width: 100%" />
      </div>
    </div>
    <div class="invoice_div">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />发票-票面备注(选填，没有备注可不用填)
        </div>
      </div>
      <div>
        <Input size="small" v-model="piaomian_remarks" maxlength="200"
          placeholder="请输入要打印到发票备注栏的信息，最多200字，不要随意填写。如有开票注意请填到Excel文件中。" style="width: 100%" />
      </div>
    </div>

    <div class="invoice_div top10">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />上传企业原表
        </div>
      </div>
      <div>
        <div class="mima_qingchu">
          提示：如文件有密码，请先清除密码后上传，确保文件无需密码可打开，否则会影响财务开票
        </div>

        <Upload :action="jiesuan_upload_file_url" :on-success="on_success" :show-upload-list="false">
          <Button size="small" type="primary" icon="ios-cloud-upload-outline" style="font-size: 12px">点击上传表格文件</Button>
        </Upload>
        <div class="view_file_div">
          <div v-for="(item, i) in jiesuan_file_url_list" :key="i">
            <div class="view_file">
              {{ jiesuan_file_name_list[i] }}
              <div title="查看文件" class="close_jiesuan_file2" @click="click_view_xls(i)">
                <Icon type="md-eye" size="20" />
              </div>
              <div title="下载文件" class="close_jiesuan_file2" @click.stop="click_down_xls(item)">
                <Icon type="md-cloud-download" size="20" />
              </div>
              <div title="删除文件" class="close_jiesuan_file" @click.stop="on_remove(i)">
                <Icon type="md-close" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="invoice_div top10">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />上传大湘统一结算表
        </div>
      </div>
      <div>
        <div class="mima_qingchu">
          提示：从企业原表中复制粘贴对应数据到公司统一结算表模板中即可
          <span class="download_template_tongyi" @click="download_universal_invoice_template">
            <Icon type="ios-cloud-download-outline" />下载统一结算模板
          </span>
        </div>

        <Upload v-if="!jiesuan_universal_file_name" :action="jiesuan_upload_file_universal_url"
          :on-success="upload_universal_success" :show-upload-list="false">
          <Button size="small" type="primary" icon="ios-cloud-upload-outline"
            style="font-size: 12px">点击上传统一结算表格</Button>
        </Upload>
        <div class="view_file_div">
          <div v-if="jiesuan_universal_file_name" class="universal_name1">
            <div class="universal_name">
              {{ jiesuan_universal_file_name }}
              <div title="查看文件" class="close_jiesuan_file2" @click="view_universal_xls()">
                <Icon type="md-eye" size="20" />
              </div>
              <div title="下载文件" class="close_jiesuan_file2" @click.stop="view_universal_xls()">
                <Icon type="md-cloud-download" size="20" />
              </div>
              <div title="删除文件" class="close_jiesuan_file" @click.stop="remove_universal()">
                <Icon type="md-close" />
              </div>
            </div>
            <div class="universal_money">
              <div>
                应发合计：{{ jiesuan_universal_yingfa_total_money }}元
              </div>
              <div>
                实发合计：{{ jiesuan_universal_shifa_total_money }}元
              </div>
              <div>
                结算人数：{{ jiesuan_people_count }}人
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="invoice_div">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon size="18" color="#0466dd" type="ios-bookmark" />上传开票资料确认表
        </div>
        <span class="kaipiaoyangli" @click="view_kaipiaoyangli">
          <Icon type="ios-eye-outline" />点击查看样例
        </span>
      </div>
      <div class="">
        <div class="mima_qingchu">
          提示：如文件有密码，请先清除密码后上传，确保文件无需密码可打开，否则会影响财务开票
        </div>

        <Upload :action="kaipiao_uploiad_url" :on-success="on_kaipiao_success" :show-upload-list="false">
          <Button size="small" type="primary" icon="ios-cloud-upload-outline" style="font-size: 12px">点击上传表格文件</Button>
        </Upload>

        <div class="view_file_div">
          <div class="view_file" v-for="(item, i) in kaipiao_xls_file_url_list" :key="i">
            {{ kaipiao_xls_file_name_list[i] }}

            <div title="查看文件" class="close_jiesuan_file2" @click="click_view_xls2(i)">
              <Icon type="md-eye" size="20" />
            </div>
            <div title="下载文件" class="close_jiesuan_file2" @click.stop="click_down_xls(item)">
              <Icon type="md-cloud-download" size="20" />
            </div>
            <div title="删除文件" class="close_jiesuan_file" @click.stop="on_kaipiao_remove(i)">
              <Icon type="md-close" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="invoice_div top10">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon size="18" color="#0466dd" type="ios-bookmark" />开票总金额(必填)
        </div>
      </div>
      <div class="mima_qingchu">
        提示：价税合计金额，金额请输入数字，前后不要有空格，不要加千分号(,)、人民币符号(￥)等特殊符号
      </div>

      <div>
        <Input @on-change="invoice_money_change" @on-blur="invoice_money_change" size="small" v-model="invoice_money"
          prefix="logo-yen" placeholder="输入开票总金额" style="width: 200px" />
      </div>
    </div>

    <div class="invoice_div">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon size="18" color="#0466dd" type="ios-bookmark" />开发票(必填)
        </div>
      </div>
      <div>
        <Button type="primary" size="small" style="font-size: 12px" @click="click_add_fapiao('0')">
          <Icon type="md-add-circle" /> 新增一张普票
        </Button>
        &nbsp;
        <Button type="success" size="small" style="font-size: 12px" @click="click_add_fapiao('1')">
          <Icon type="md-add-circle" /> 新增一张专票
        </Button>
      </div>
    </div>

    <div class="invocie_views">
      <div class="title">
        <div class="ios_bookmark_div">
          <Icon type="ios-bookmark" size="18" color="#0466dd" />发票样例预览（共{{
            template_invoice_list.length
          }}张）
        </div>
      </div>
      <div class="invoice_template_div">
        <invoice_template @del="invoice_del" ref="invoice_template" :invoice_list="template_invoice_list">
        </invoice_template>
      </div>
    </div>
    <div class="invoice_div top10">
      <div class="title">
        <div>
          <Icon type="ios-bookmark" size="18" color="#0466dd" />指定发票文件类型（必填）
        </div>
      </div>
      <div style="padding-left: 20px">
        <RadioGroup v-model="invoice_file_type">
          <Radio label="PDF"></Radio>
          <Radio label="OFD"></Radio>
          <Radio label="PDF+OFD"></Radio>
          <Radio label="XML"></Radio>
          <Radio label="PDF+XML"></Radio>
          <Radio label="OFD+XML"></Radio>
        </RadioGroup>
      </div>
    </div>

    <div class="invoice_div top10">
      <div class="title">
        <div>
          <Icon type="ios-bookmark" size="18" color="#0466dd" />发票邮寄地址（必填）
        </div>

        <div class="title_right">
          <div class="add_invoice_title2" @click="export_address">
            <Icon type="ios-cloud-download-outline" /> 导出地址
          </div>
          <div class="add_invoice_title" @click="click_add_address">
            <Icon type="md-add-circle" /> 添加地址
          </div>
        </div>
      </div>
      <!-- {{  express_select}} -->
      <Table @on-selection-change="express_address_table_change" size="small" :columns="address_columns"
        :data="address_list" ref="address">
        <template #email="{ row }">
          <span>{{ row.email ? row.email : "待完善" }}&nbsp;
            <Icon @click="click_update_address_email(row)" v-if="row.email == ''" size="18" class="create_email"
              type="ios-create" />
          </span>
        </template>
        <template #action="{ row }">
          <div>
            <span class="del_invoice" @click="del_address_click(row)">删除</span>
          </div>
        </template>
      </Table>
    </div>

    <div class="jiesuan_button">
      <div class="youji_tishi" v-if="express_select.length == 0">
        提示：本次结算发票没有选择邮寄地址
      </div>
      <Button type="primary" style="font-size: 14px" @click="click_jiesuan" :loading="submit_loading">
        <Icon type="md-checkmark-circle" /> 确认提交开票申请
      </Button>
    </div>
    <div style="height: 100px; width: 100px"></div>

    <Drawer v-model="add_invoice_modal_show" title="添加发票" :mask-closable="true" :closable="true" width="80">
      <div class="zhuti_div">
        <div class="zhuti_title">开票主体：</div>
        <Select filterable clearable v-model="subject_id" style="width: 300px" size="small" @on-change="subject_change"
          @on-clear="make_invoice_tex_rate_list = []">
          <Option v-for="item in subject_list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div class="zhuti_div">
        <div class="zhuti_title">发票类型：</div>
        <Select disabled v-model="invoice_type" style="width: 300px" size="small" @on-change="invoice_type_change">
          <Option value="0">普票</Option>
          <Option value="1">专票</Option>
        </Select>
      </div>


      <div class="zhuti_div">
        <div class="select_tex_rate">发票税率：</div>
        <span class="select_tex_span">点击下方选择</span>
      </div>

      <div class="add_tex_rate_tag_div">
        <div v-for="(item, i) in make_invoice_tex_rate_list" :key="i" class="add_tex_rate_tag"
          @click="click_tex_rate_tag(item)">
          <span class="rate_project_name">{{ item.project_name }}</span>
          
          <!-- <div class="add_tex_rate_num2" v-if="item.make_invoice_type == 0">全额</div>
          <div class="add_tex_rate_num3" v-if="item.make_invoice_type == 1">差额</div> -->
          <div class="add_tex_rate_num">{{ item.tex_rate }}%</div>
        </div>
      </div>

      <div>
        <!-- <div v-for="(item,i) in add_texrate_table_data" :key="i">
                    
                    <span>{{ item.project_group_name }}</span>
                    <span>{{ item.project_name }}</span>
                    <span>{{ item.project_yingshou_money }}</span>
                    
                </div> -->
        <Table size="small" :columns="add_texrate_columns" :data="add_texrate_table_data">
          <template #tex_rate="{ row }"> {{ row.tex_rate }}% </template>
          <template #action="{ row }">
            <Button type="error" style="font-size: 12px" size="small" @click="del_texrate_table_line(row)">
              <Icon type="md-trash" />
              删除
            </Button>
          </template>
        </Table>
      </div>
      <div class="add_invoice_button top30">
        <Button type="primary" @click="add_invoice_drawer_confirm" style="font-size: 12px">
          <Icon type="md-checkmark-circle" />
          确认添加
        </Button>
      </div>
    </Drawer>

    <Modal v-model="update_address_email_show" title="更新邮寄地址-电子邮箱" :mask-closable="false" :footer-hide="true"
      width="400">
      <Input v-model="update_address_email_text" prefix="ios-mail-open" placeholder="请输入电子邮箱，格式 xxx@xx.com"
        style="width: 100%" />
      <div class="add_invoice_button top30">
        <Button type="primary" @click="update_address_email_request" style="font-size: 12px">
          <Icon type="md-checkmark-circle" />
          确认更新
        </Button>
      </div>
    </Modal>

    <Modal v-model="update_email_show" title="更新电子邮箱" :mask-closable="false" :footer-hide="true" width="400">
      <Input v-model="update_email_txt" prefix="ios-mail-open" placeholder="请输入电子邮箱，格式 xxx@xx.com"
        style="width: 100%" />
      <div class="add_invoice_button top30">
        <Button type="primary" @click="update_email_request" style="font-size: 12px">
          <Icon type="md-checkmark-circle" />
          确认更新
        </Button>
      </div>
    </Modal>

    <Modal v-model="add_texrate_show" title="发票开票项目添加" :mask-closable="false" :footer-hide="true" width="500">
      <div>
        <Alert v-if="tax_deduction == 0" style="width:100%" type="warning">【重要提示】当前项目没有编辑免税扣除额权限，<span
            style="font-weight: 600;">如果差额开票的发票类目需要开到一条上的</span>，请联系财务打开权限，否则默认开票按发票样例开出，请知悉！<span
            class="tishi_error">第一次不会操作的请问一下财务，特别是差额开票，不要乱填😵‍💫！</span></Alert>
        <Alert v-else type="success"> 免税扣除额编辑权限已开，如果差额开票的发票类目需要开到一条上的，请在免税扣除额栏填入【不算免税部分】的金额，不会填请先咨询财务。<span
            class="tishi_error">第一次不会操作的请问一下财务，特别是差额开票，不要乱填😵‍💫！</span></Alert>
      </div>
      <div>
        <div class="mima_qingchu">
          提示：金额请输入数字，前后不要有空格，不要加千分号(,)、人民币符号(￥)等特殊符号
        </div>
        <div class="add_input_class">
          <div class="add_input_class_title">价税合计金额</div>
          <Input @on-change="add_texrate_input_change" @on-blur="add_texrate_input_change" v-model="add_texrate_input"
            prefix="logo-yen" placeholder="请输入金额" style="width: 200px" />
        </div>
        <!-- <div>
          价款：{{ add_texrate_input_price }}
        </div>
        <div>
          税额：{{ add_texrate_input_tax }}
        </div> -->
      </div>
      <div>
        <div class="add_input_class">
          <div class="add_input_class_title">数量</div>
          <Input disabled v-model="add_texrate_input_count" prefix="logo-yen" placeholder="" style="width: 200px" />
        </div>
      </div>
      <!-- <div class="zhuti_div">
        <div class="zhuti_title">是否差额开票：</div>
        <Select v-model="difference" style="width: 200px"  @on-change="difference_change">
          <Option value="差额">差额</Option>
          <Option value="非差额">非差额</Option>
        </Select>
      </div> -->
      <div class="add_input_class">
        <div class="add_input_class_title">免税扣除额</div>
        <Input :disabled="tax_deduction == 0 ? true : false" @on-change="add_texrate_deduction_change"
          @on-blur="add_texrate_deduction_change" v-model="add_texrate_input_deduction" prefix="logo-yen"
          placeholder="请输入金额 " style="width: 200px" />
        <div style="margin-left:10px" v-if="tax_deduction == 1">
          <Icon type="md-checkmark-circle" color="green" /><span
            style="color:#333;margin-left: 3px;font-size: 13px;">权限已开</span>
        </div>
        <div style="margin-left:10px" v-else>

          <Icon type="md-close-circle" color="red" /><span
            style="color:#333;margin-left: 3px;font-size: 13px;">权限未开</span>
        </div>
      </div>
      <div class="add_invoice_button">
        <Button type="primary" @click="add_texrrate_tag_confirm">确认添加</Button>
      </div>
    </Modal>

    <Modal v-model="add_invoice_show" title="添加抬头" :mask-closable="false" :footer-hide="true" width="500">
      <div class="add_invoice_input">
        <div class="add_invoice_field">*公司全称：</div>
        <Input size="small" v-model="add_invoice_data.company_name" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">*税号：</div>
        <Input size="small" v-model="add_invoice_data.tax_num" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">开户行名称：</div>
        <Input size="small" v-model="add_invoice_data.bank_name" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">开户行帐号：</div>
        <Input size="small" v-model="add_invoice_data.bank_num" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">企业注册地址：</div>
        <Input size="small" v-model="add_invoice_data.company_place" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">企业电话：</div>
        <Input size="small" v-model="add_invoice_data.company_phone" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_button">
        <Button type="primary" @click="add_invoice_confirm">确认添加</Button>
      </div>
    </Modal>

    <Modal v-model="add_address_show" title="添加邮寄地址" :mask-closable="false" :footer-hide="true" width="500">
      <div class="add_invoice_input">
        <div class="add_invoice_field">*姓名：</div>
        <Input size="small" v-model="add_address_item.name" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">*手机号：</div>
        <Input size="small" v-model="add_address_item.phone" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">*详细地址：</div>
        <Input size="small" v-model="add_address_item.detail" placeholder="请输入..." style="width: 300px" />
      </div>
      <div class="add_invoice_input">
        <div class="add_invoice_field">*邮箱：</div>
        <Input size="small" v-model="add_address_item.email" placeholder="请输入正确邮箱格式 xxx.xxx.com" style="width: 300px" />
      </div>

      <div class="add_invoice_button">
        <Button type="primary" @click="add_address_confirm">确认添加</Button>
      </div>
    </Modal>

    <Modal v-model="jiesuan_success_show" title="提交结算成功" :footer-hide="true" width="500">
      <div class="jieusnasuccess_div">
        <div>
          <Icon type="ios-checkmark-circle" color="#0466dd" size="50" />
        </div>
        <div class="jieusnasuccess_title">提交结算成功，请不要重复提交！</div>
      </div>
      <div class="jiesuan_success_button_div">
        <div class="jiesuan_success_button">
          <Button type="primary" @click="click_close_windows">关闭当前页面</Button>
        </div>
        <div class="jiesuan_success_button">
          <Button type="" @click="click_continue_to_submit">继续提交</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="teshu_import_show" title="特殊项目-批量结算发起" :mask-closable="false" :footer-hide="true" width="650">
      <div class="batch_import_div">
        <div>模板列表（请下载符合的模板）</div>

        <div class="template_a">
          <div class="template_a_herf" @click="click_down_template_batch(item)" v-for="(item, i) in batch_template_list"
            :key="i">
            {{ item.template_name }}
          </div>
        </div>
        <div style="height: 20px"></div>
        <!-- 
            <div class="" style="margin-bottom:15px">
                <div class="title">
                    <div>
                        <Icon type="ios-bookmark" />项目发票抬头(必填)
                    </div>
                </div>
                <div>
                    <Input search @on-enter="search_invoice_title_change" @on-search="search_invoice_title_change"
                        size="small" v-model="search_invoice_title" placeholder="名称筛选抬头,按回车搜索" style="width: 200px" />
                </div>
                <Table max-height="300" @on-selection-change='table_selection_change' size="small"
                    :columns="invoice_columns" :data="invoice_list" ref="table_invoice">
                    <template #action="{ row }">
                        <span @click="invoice_del_title(row)" class="del_invoice">删除</span>
                    </template>
                </Table>
            </div> -->

        <div class="title">
          <div class="ios_bookmark_div">
            <Icon type="ios-bookmark" />上传结算表/企业原表
          </div>
        </div>
        <div>
          <Upload :action="jiesuan_upload_file_url" :on-success="on_success" :show-upload-list="false">
            <Button size="small" type="primary" icon="ios-cloud-upload-outline"
              style="font-size: 12px">点击上传表格文件</Button>
          </Upload>
          <div class="view_file_div">
            <div v-for="(item, i) in jiesuan_file_url_list" :key="i">
              <div class="view_file">
                {{ jiesuan_file_name_list[i] }}
                <!-- {{ jiesuan_file_list[i].slice(-20) }} -->
                <div title="查看文件" class="close_jiesuan_file2" @click="click_view_xls(i)">
                  <Icon type="md-eye" size="20" />
                </div>
                <div title="下载文件" class="close_jiesuan_file2" @click.stop="click_down_xls(item)">
                  <Icon type="md-cloud-download" size="20" />
                </div>
                <div title="删除文件" class="close_jiesuan_file" @click.stop="on_remove(i)">
                  <Icon type="md-close" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 20px"></div>

        <div class="title">
          <div class="ios_bookmark_div">
            <Icon type="ios-bookmark" />上传模板文件
          </div>
        </div>

        <div class="">
          <Upload ref="batch_import" :action="batch_jiesuan_url" :on-success="on_batch_import_file_success">
            <Button size="small" type="primary" icon="ios-cloud-upload-outline"
              style="font-size: 12px">点击上传完善后的模板文件</Button>
          </Upload>
        </div>

        <div class="batch_btn_div">
          <Button type="primary" @click="batch_import_confirm">确认提交</Button>
        </div>
      </div>
    </Modal>

    <Modal title="温馨提示" v-model="submit_confirm_show" @on-ok="click_jiesuan_confirm"
      @on-cancel="submit_confirm_show = false" ok-text="确认提交" cancel-text="检查一下再提交">
      <p>正在提交开票申请，近期提交出错概率较大，强烈建议再次检查一下再提交！</p>
    </Modal>


    <Modal title="提示" v-model="tishi_show">
      <p>2026年大象系统开票功能全面升级🎉🎉，将打通财务金蝶支持一键开票。发票样例看到什么样的，财务就会开什么样的，请各位小伙伴务必仔细检查与确认哦！✌️</p>
    </Modal>

    <Modal v-model="caiwu_code_show" title="提示" :mask-closable="false" :closable="false" :footer-hide="true"
      width="400">
      <div>
        <div>
          当前项目无法进行开票。原因：{{ caiwu_code_show_msg }}。请联系财务[陈红]添加编码。🤙🤙🤙
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { get_view_file_url, http, open_new_page } from "@/utils/http.js";
import invoice_template from "./invoice_template";
var Base64 = require("js-base64").Base64;
import menu2 from "@/component/menu/menu2.vue";

import getFileUrl from "@/lib/entry.js";

export default {
  components: {
    menu2,
    invoice_template,
  },

  data() {
    return {
      search_invoice_title: "",
      project_id: "",
      invoice_columns: [],
      invoice_list: [],
      add_invoice_show: false,
      add_invoice_data: {
        company_name: "",
        tax_num: "",
        bank_name: "",
        bank_num: "",
        company_place: "",
        company_phone: "",
      },
      invoice_money: "",
      jiesuan_remarks: "",
      piaomian_remarks: "",
      add_invoice_modal_show: false,
      subject_list: [],
      subject_id: "",
      invoice_type: "0",
      difference: '差额',

      make_invoice_tex_rate_list: [],
      add_texrate_show: false,
      add_texrate_input: "",
      add_texrate_input_price: '',
      add_texrate_input_tax: '',
      // 税-扣除额
      add_texrate_input_deduction: '0',
      add_texrate_input_count: 1,
      add_texrate_tag_item: {},
      express_select: [],

      add_texrate_columns: [
        {
          title: "项目名",
          key: "project_name",
        },
        {
          title: "税率",
          slot: "tex_rate",
        },
        {
          title: "价税合计",
          key: "money",
        },
        {
          title: "免税扣除额",
          key: "deduction",
        },
        {
          title: "单价",
          key: "price",
        },

        {
          title: "税额",
          key: "tax",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      add_texrate_table_data: [],

      template_invoice_list: [],
      table_invoice_selection: [],

      address_list: [],
      address_columns: [],
      add_address_show: false,
      add_address_item: {
        name: "",
        phone: "",
        detail: "",
        email: "",
      },

      project_info: {
        project_name: "-",
      },

      //结算表统一模板
      jiesuan_universal_file_name: '',
      jiesuan_universal_file_object_name: '',
      jiesuan_universal_file_url: '',
      jiesuan_upload_file_universal_url:
        process.env.VUE_APP_HOST +
        "/finance/invoice/upload_jiesuan_universal?token=" +
        this.$cookies.get("dx_token"),
      // 结算总应发合计金额
      jiesuan_universal_yingfa_total_money: 0,
      //结算总实发金额
      jiesuan_universal_shifa_total_money: 0,
      jiesuan_people_count: 0,
      jiesuan_universal_batch_id: '',



      //结算表列表
      jiesuan_file_list: [],
      jiesuan_file_name_list: [],
      jiesuan_file_url_list: [],
      jiesuan_upload_file_url:
        process.env.VUE_APP_HOST +
        "/finance/invoice/upload_jiesuan?token=" +
        this.$cookies.get("dx_token"),

      // 开票资料确认表
      kaipiao_xls_file_list: [],
      kaipiao_xls_file_name_list: [],
      kaipiao_xls_file_url_list: [],
      kaipiao_uploiad_url:
        process.env.VUE_APP_HOST +
        "/finance/invoice/upload_fapiao?token=" +
        this.$cookies.get("dx_token"),

      //批量结算
      batch_jiesuan_url:
        process.env.VUE_APP_HOST +
        "/finance/invoice/upload_import_template?token=" +
        this.$cookies.get("dx_token"),
      //
      batch_jiesuan_file: "",
      //
      teshu_import_show: false,

      //
      jiesuan_success_show: false,
      // 结算年月
      jiesuan_year_month: "",
      jiesuan_year_month_status: "j1",

      //
      batch_template_list: [],

      update_email_show: false,
      update_email_item: {},
      update_email_txt: "",

      // 更新邮寄地址邮箱
      update_address_email_show: false,
      update_address_email_item: {},
      update_address_email_text: "",

      // 指定发票文件类型
      invoice_file_type: "PDF",

      submit_confirm_show: false,

      //统一结算表模板
      universal_excel_template_url: '',


      tishi_show: true,
      submit_loading: false,

      tax_deduction: 0,
      caiwu_code_show: false,
      caiwu_code_show_msg: ''

    };
  },

  mounted() {
    this.project_id = this.$route.query.project_id;
    this.get_project_caiwu_code();
    this.get_invoice_title_list();

    this.invoice_texrate_list();
    //
    this.get_address_list();
    //
    this.get_batch_template();
    //
    this.get_universal_excel_template()
    // 
    this.get_project_tax_deduction()
  },
  methods: {


    //下载模板
    download_universal_invoice_template() {
      open_new_page(this.universal_excel_template_url)
    },

    update_address_email_request() {
      var that = this;
      var obj = {
        address_id: this.update_address_email_item.address_id,
        email: this.update_address_email_text,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/update_address_email",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_address_email_show = false;
            that.get_address_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 点击更新邮寄地址邮箱
    click_update_address_email(row) {
      this.update_address_email_item = row;
      this.update_address_email_show = true;
    },

    // 更新抬头邮箱
    update_email_request() {
      var that = this;
      var obj = {
        pit_id: this.update_email_item.pit_id,
        email: this.update_email_txt,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/update_email", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.update_email_show = false;
            that.get_invoice_title_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新抬头邮箱
    click_update_email(row) {
      this.update_email_item = row;
      this.update_email_show = true;
    },

    invoice_money_change() {
      var s1 = this.invoice_money;
      console.log(s1);
      var s2 = String(s1).replace(",", "");
      var s3 = s2.trim();
      var that = this;
      console.log(s3);
      setTimeout(function () {
        that.invoice_money = s3;
      }, 100);
    },

    add_texrate_deduction_change() {
      var s1 = this.add_texrate_input_deduction;
      var s2 = String(s1).replace(",", "");
      var s3 = s2.trim();
      var that = this;
      setTimeout(function () {
        that.add_texrate_input_deduction = s3;
      }, 100);

      var m1 = parseFloat(this.add_texrate_input)
      var m2 = parseFloat(s3)
      if (m2 > m1) {
        this.$Message.error('免税扣除额不可大于开票金额')
      }
    },

    add_texrate_input_change() {
      var s1 = this.add_texrate_input;
      var s2 = String(s1).replace(",", "");
      var s3 = s2.trim();
      console.log(s3);
      var that = this;
      setTimeout(function () {
        that.add_texrate_input = s3;
      }, 100);

      // 如果是0税额的，默认是免税需要扣除
      if (this.add_texrate_tag_item.tex_rate == 0) {
        this.add_texrate_input_deduction = s3
      }

      console.log(this.add_texrate_tag_item)
      // 算出价款与税额
      // this.calculateFromTotal(s3,6);
    },

    search_invoice_title_change() {
      var list1 = [];
      for (var i = 0; i < this.invoice_list.length; i++) {
        var company_name = this.invoice_list[i]["company_name"];

        if (company_name.indexOf(this.search_invoice_title) != -1) {
          console.log("找到");
          list1.push(this.invoice_list[i]);
        }
      }
      console.log(list1);
      this.invoice_list = list1;

      if (this.search_invoice_title == "") {
        this.get_invoice_title_list();
      }
    },

    get_universal_excel_template() {
      var that = this;
      var obj = {
      };
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/universal_excel_template", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.universal_excel_template_url = res.data.url
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //批量导入确认
    batch_import_confirm() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        template_file: this.batch_jiesuan_file,
        jiesuan_file_list: this.jiesuan_file_list,
        express: this.express_select,
      };
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/batch_import", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.teshu_import_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //批量导入文件上传完成
    on_batch_import_file_success(e) {
      // this.$refs.batch_import.clearFiles();
      console.log(e);
      this.batch_jiesuan_file = e.data.object_name;
    },

    click_add_fapiao(status) {
      this.invoice_texrate_list();
      this.click_add_invoice(status);
      this.make_invoice_tex_rate_list = [];
      this.subject_id = "";
    },

    click_continue_to_submit() {
      this.jiesuan_success_show = false;
      location.reload();
    },

    click_close_windows() {
      console.log("关闭窗口");
      window.opener = null;
      window.open("", "_self");
      window.close();
    },

    view_kaipiaoyangli() {
      this.$ImagePreview.show({
        previewList: ["https://static.daxiangsys.com/dx-short-link/png/9IB4drX9Ub.png"],
      });
    },

    view_universal_xls() {
      get_view_file_url(this.jiesuan_universal_file_object_name);
    },
    // 下载统一结算表
    download_universal_xls() {

    },
    remove_universal() {
      this.jiesuan_universal_file_name = ''
      this.jiesuan_universal_file_object_name = ''
      this.jiesuan_universal_file_url = ''
      this.$Message.success('删除成功')
    },

    click_view_xls(index) {
      console.log(index);
      get_view_file_url(this.jiesuan_file_list[index]);
      // get_view_file_url(url_str)
      // getFileUrl(url_str);
      // var file_url =
      //   "https://kkfile.daxiangsys.com/onlinePreview?url=" +
      //   encodeURIComponent(Base64.encode(url_str));
      // open_new_page(file_url);
    },

    click_view_xls2(index) {
      console.log(index);
      get_view_file_url(this.kaipiao_xls_file_list[index]);
      // get_view_file_url(url_str)
      // getFileUrl(url_str);
      // var file_url =
      //   "https://kkfile.daxiangsys.com/onlinePreview?url=" +
      //   encodeURIComponent(Base64.encode(url_str));
      // open_new_page(file_url);
    },

    click_down_xls(url_str) {
      open_new_page(url_str);
    },

    on_remove(index) {
      this.jiesuan_file_list.splice(index, 1);
      this.jiesuan_file_url_list.splice(index, 1);
      this.$Message.success("删除成功");
    },

    on_success(e) {
      console.log(e);

      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.jiesuan_file_list.push(e.data.object_name);
        this.jiesuan_file_name_list.push(e.data.filename);
        this.jiesuan_file_url_list.push(e.data.url);
      } else {
        this.$Message.error(e.msg);
      }
    },

    on_kaipiao_remove(index) {
      this.kaipiao_xls_file_list.splice(index, 1);
      this.kaipiao_xls_file_url_list.splice(index, 1);
      this.$Message.success("删除成功");
    },
    on_kaipiao_success(e) {
      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.kaipiao_xls_file_list.push(e.data.object_name);
        this.kaipiao_xls_file_name_list.push(e.data.filename);
        this.kaipiao_xls_file_url_list.push(e.data.url);
      } else {
        this.$Message.error(e.msg);
      }
    },

    del_address_click(row) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除邮寄地址，是否继续？</p>",
        onOk: () => {
          that.del_address(row);
        },
        onCancel: () => { },
      });
    },

    del_address(row) {
      var that = this;
      var obj = {
        address_id: row.address_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/express_address_del",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_address_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_address_confirm() {
      var that = this;
      var obj = {
        project_id: this.project_id,
        name: this.add_address_item.name,
        phone: this.add_address_item.phone,
        detail: this.add_address_item.detail,
        email: this.add_address_item.email,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/express_address_add",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.add_address_show = false;
            that.get_address_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_add_address() {
      this.add_address_show = true;
    },

    get_project_tax_deduction() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/project_deduction_status",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.tax_deduction = res.data.tax_deduction;

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取地址列表
    get_address_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/express_address",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.address_list = res.data.address_list;
            that.address_columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    table_selection_change(e) {
      // if(this.table_invoice_selection.length>0 && e.length >0){
      //     this.$Message.error('只能选个开票抬头，请先取消另一个')
      //     return
      // }
      if (e.length > 1) {
        this.table_invoice_selection = [];
        for (var i = 0; i < this.invoice_list.length; i++) {
          this.invoice_list[i]["_checked"] = false;
          this.invoice_list[i]["_disabled"] = false;
        }
        this.$Message.error("禁止全选");
        return;
      }

      if (this.table_invoice_selection.length == 0 && e.length > 0) {
        this.table_invoice_selection = e;
        // 将其他设置为不可选中
        var pit_id = this.table_invoice_selection[0]["pit_id"];

        for (var i = 0; i < this.invoice_list.length; i++) {
          if (this.invoice_list[i]["pit_id"] == pit_id) {
            this.invoice_list[i]["_checked"] = true;
          } else {
            this.invoice_list[i]["_disabled"] = true;
          }
        }
      }

      if (e.length == 0) {
        this.table_invoice_selection = [];
        for (var i = 0; i < this.invoice_list.length; i++) {
          this.invoice_list[i]["_checked"] = false;
          this.invoice_list[i]["_disabled"] = false;
        }
      }

      console.log(e);
      // this.$refs.table_invoice.selectAll(false);
    },

    express_address_table_change(e) {
      // if(this.table_invoice_selection.length>0 && e.length >0){
      //     this.$Message.error('只能选个开票抬头，请先取消另一个')
      //     return
      // }
      if (e.length > 1) {
        this.express_select = [];
        for (var i = 0; i < this.address_list.length; i++) {
          this.address_list[i]["_checked"] = false;
          this.address_list[i]["_disabled"] = false;
        }
        this.$Message.error("禁止全选");
        return;
      }

      if (this.express_select.length == 0 && e.length > 0) {
        this.express_select = e;
        // 将其他设置为不可选中
        var address_id = this.express_select[0]["address_id"];

        for (var i = 0; i < this.address_list.length; i++) {
          if (this.address_list[i]["address_id"] == address_id) {
            this.address_list[i]["_checked"] = true;
          } else {
            this.address_list[i]["_disabled"] = true;
          }
        }
      }

      if (e.length == 0) {
        this.express_select = [];
        for (var i = 0; i < this.address_list.length; i++) {
          this.address_list[i]["_checked"] = false;
          this.address_list[i]["_disabled"] = false;
        }
      }

      console.log(e);
      // this.$refs.table_invoice.selectAll(false);
    },

    del_texrate_table_line(row) {
      console.log(row);
      var index = row._index;
      this.add_texrate_table_data.splice(index, 1);
    },

    isStrictNumber(str) {
      // 不允许前导0（除非就是0本身）
      return /^(0|([1-9]\d*))(\.\d+)?$/.test(str);
    },

    add_texrrate_tag_confirm() {
      if (this.add_texrate_input == "") {
        this.$Message.error("请先输入金额");
        return;
      }
      if (!this.isStrictNumber(this.add_texrate_input)) {
        this.$Message.error("价税合计金额格式异常，请检查");
        return;
      }
      if (this.add_texrate_input_deduction == "") {
        this.$Message.error("请先输入免税扣除金额");
        return;
      }
      if (!this.isStrictNumber(this.add_texrate_input_deduction)) {
        this.$Message.error("免税扣除金额异常，请检查");
        return;
      }
      this.add_texrate_tag_item["money"] = this.add_texrate_input;
      console.log("要添加的金额", this.add_texrate_input);
      console.log("税率", this.add_texrate_tag_item.tex_rate);

      // 生成价款与税金
      const rate = this.add_texrate_tag_item.tex_rate / 100;  // 转小数

      // 免税金额
      var taxablePrice = (parseFloat(this.add_texrate_input) - parseFloat(this.add_texrate_input_deduction)) / (1 + rate);
      var taxAmount = taxablePrice * rate;

      var price = parseFloat(this.add_texrate_input) - taxAmount

      // // 减掉免税金额 
      // if (parseFloat(this.add_texrate_input_deduction) > 0) {
      //   // 计算不含税价格（保留4位小数计算）
      //   // 税额 = (价税合计金额 - 免税扣除金额) * 税率 / (1 + 税率)
      //   // 价款 = 价税合计金额 - 税额
      //   var taxAmount = ( parseFloat(this.add_texrate_input) -  parseFloat(this.add_texrate_input_deduction) ) / (1 + rate);
      //   console.log('++++++++++1',taxAmount)
      // var price =  parseFloat(this.add_texrate_input) -  taxAmount
      //   console.log('++++++++++',price)

      // } else {
      //   // 计算税额
      //   var taxAmount = parseFloat(this.add_texrate_input) - price;
      // }


      // 保留2位小数（财务常用）
      var price_2 = Math.round(price * 100) / 100
      var shuie_2 = Math.round(taxAmount * 100) / 100
      this.add_texrate_tag_item["price"] = price_2
      // 单价
      this.add_texrate_tag_item["unit_price"] = price_2
      // 数量
      this.add_texrate_tag_item["count"] = 1
      this.add_texrate_tag_item["tax"] = shuie_2
      console.log(this.add_texrate_tag_item)
      // 免税额
      this.add_texrate_tag_item["deduction"] = this.add_texrate_input_deduction

      this.add_texrate_table_data.push(
        JSON.parse(JSON.stringify(this.add_texrate_tag_item))
      );
      this.add_texrate_show = false;
      // 清空输入框
      this.add_texrate_input = '';
      this.add_texrate_input_deduction = '0'

    },

    click_tex_rate_tag(item) {
      console.log(item);
      this.add_texrate_tag_item = item;
      var trid = item.trid;
      this.add_texrate_show = true;
      this.get_project_tax_deduction()
    },

    subject_change(e) {
      console.log(e);
      if (e) {
        var current_item = {};
        for (var i = 0; i < this.subject_list.length; i++) {
          if (this.subject_list[i]["value"] == e) {
            current_item = this.subject_list[i];

            if (this.invoice_type == "0") {
              console.log(this.subject_list[i]);
              this.make_invoice_tex_rate_list = current_item["pupiao"];
            }
            if (this.invoice_type == "1") {
              this.make_invoice_tex_rate_list = current_item["zhuanpiao"];
            }
          }
        }
      }
      console.log(current_item);
    },

    invoice_texrate_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/invoice_texrate",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.subject_list = res.data.subject_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_add_invoice(e) {
      if (this.table_invoice_selection.length != 1) {
        this.$Message.error("请先勾选一个发票抬头");
        return;
      }

      if (this.invoice_money == "") {
        this.$Message.error("请先输入结算总金额");
        return;
      }

      this.invoice_type = e;

      this.add_invoice_modal_show = true;
      this.add_texrate_table_data = [];
    },

    get_project_caiwu_code() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/get_project_caiwu_code",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {

          } else {

            that.caiwu_code_show = true
            that.caiwu_code_show_msg = res.msg;

          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    invoice_del_request(row) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        pit_id: row.pit_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/project_invoice_del",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.get_invoice_title_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    invoice_del_title(row) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认要删除这个抬头吗？</p>",
        onOk: () => {
          that.invoice_del_request(row);
        },
        onCancel: () => { },
      });
    },

    add_invoice_confirm() {
      console.log("点击确认");
      if (this.add_invoice_data.company_name == "") {
        this.$Message.error("请输入公司全称");
        return;
      }
      if (this.add_invoice_data.tax_num == "") {
        this.$Message.error("请输入税号");
        return;
      }

      var that = this;
      var obj = {
        project_id: this.project_id,
        company_name: this.add_invoice_data.company_name,
        tax_num: this.add_invoice_data.tax_num,
        bank_name: this.add_invoice_data.bank_name,
        bank_num: this.add_invoice_data.bank_num,
        company_place: this.add_invoice_data.company_place,
        company_phone: this.add_invoice_data.company_phone,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/project_invoice_add",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            this.add_invoice_show = false;
            this.get_invoice_title_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    difference_change(e) {

    },

    invoice_type_change(e) {
      console.log(e);
      var current_item = {};
      for (var i = 0; i < this.subject_list.length; i++) {
        if (this.subject_list[i]["value"] == this.subject_id) {
          current_item = this.subject_list[i];
          break;
        }
      }

      if (e == 0) {
        this.make_invoice_tex_rate_list = current_item["pupiao"];
      }
      if (e == 1) {
        this.make_invoice_tex_rate_list = current_item["zhuanpiao"];
      }
    },

    add_invoice() {
      this.add_invoice_show = true;
    },

    export_invoice_table() {
      this.$refs.table_invoice.exportCsv({
        filename: "抬头",
      });
    },
    export_address() {
      this.$refs.address.exportCsv({
        filename: "邮寄地址",
      });
    },

    //获取发票抬头
    get_invoice_title_list() {
      var query = this.$route.query;
      var project_id = query.project_id;
      console.log(project_id);
      if (!project_id) {
        alert("参数异常");
        return;
      }
      var that = this;
      var obj = {
        project_id: project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/project_invoice",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.invoice_list = res.data.title_list;
            that.invoice_columns = res.data.columns;
            that.project_info = res.data.project_info;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_pdf(url) {
      open_new_page(url);
    },

    add_invoice_drawer_confirm() {
      console.log("确认添加发票");
      var _dict = {
        subject_id: this.subject_id,
        invoice_type: this.invoice_type,
        tax_rate_list: this.add_texrate_table_data,
        invoice_data: this.table_invoice_selection,
        piaomian_remarks: this.piaomian_remarks,
      };
      this.template_invoice_list.push(_dict);
      // 更新所有发票的票面备注
      for (var i = 0; i < this.template_invoice_list.length; i++) {
        this.template_invoice_list[i]['piaomian_remarks'] = this.piaomian_remarks
      }
      this.add_invoice_modal_show = false;
      console.log(this.template_invoice_list)

      this.$refs.invoice_template.add(this.template_invoice_list);

      // 清空
      // this.make_invoice_tex_rate_list = []
    },

    click_kaipiao_record() {
      var query = this.$route.query;
      open_new_page("/finance/kaipiao_detail?project_id=" + query.project_id);
    },

    invoice_del(index) {
      this.template_invoice_list.splice(index, 1);
    },

    shangyue() {
      var currentDate = new Date();
      var currentMonth = currentDate.getMonth();
      var currentYear = currentDate.getFullYear();
      var prevMonth, prevYear;
      if (currentMonth === 0) {
        // 一月份情况
        prevMonth = 12;
        prevYear = currentYear - 1;
      } else {
        prevMonth = currentMonth;
        prevYear = currentYear;
      }
      return [prevYear, prevMonth];
    },

    benyue() {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      return [year, month];
    },

    click_jiesuan_month_btn() {
      if (this.jiesuan_year_month_status == "j1") {
        // 上月

        var currentDate = new Date();
        var currentMonth = currentDate.getMonth();
        var currentYear = currentDate.getFullYear();
        var prevMonth, prevYear;
        if (currentMonth === 0) {
          // 一月份情况
          prevMonth = 12;
          prevYear = currentYear - 1;
        } else {
          prevMonth = currentMonth;
          prevYear = currentYear;
        }
        this.jiesuan_year_month = [prevYear, prevMonth];
      }
      if (this.jiesuan_year_month_status == "j2") {
        // 本月

        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        this.jiesuan_year_month = [year, month];
      }

      if (this.jiesuan_year_month_status == "j3") {
        var jiesuan_year = this.jiesuan_year_month.getFullYear();
        var jiesuan_month = this.jiesuan_year_month.getMonth() + 1;
        this.jiesuan_year_month = [jiesuan_year, jiesuan_month];
      }
    },

    click_jiesuan() {
      var that = this;
      that.submit_confirm_show = true;
    },

    //点击结算
    click_jiesuan_confirm() {
      console.log("点击结算");
      // 计算归属年月
      this.click_jiesuan_month_btn();

      console.log(this.template_invoice_list);
      var query = this.$route.query;
      var project_id = query.project_id;

      if (this.jiesuan_year_month == "") {
        this.$Message.error("请选择结算归属属年月");
        return;
      } else {
        if (Array.isArray(this.jiesuan_year_month)) {
          var jiesuan_year = this.jiesuan_year_month[0];
          var jiesuan_month = this.jiesuan_year_month[1];
        } else {
          this.$Message.error("结算归属属年月出错");
          return;
        }
      }

      if (this.template_invoice_list.length == 0) {
        this.$Message.error("请先添加发票");
        return;
      }

      if (this.jiesuan_remarks == "") {
        this.$Message.error("请填写结算说明");
        return;
      }

      // if (this.jiesuan_file_list.length == 0) {
      //   this.$Message.error("请先上传结算表");
      //   return;
      // }

      // if (this.kaipiao_xls_file_list.length == 0) {
      //   this.$Message.error("请先上传开票资料确认表");
      //   return;
      // }
      // if (this.kaipiao_xls_file_list.length > 1) {
      //   this.$Message.error("开票资料表只可上传1个");
      //   return;
      // }
      // if (this.jiesuan_universal_file_object_name.length == 0) {
      //   this.$Message.error("请上传结算表");
      //   return;
      // }

      var that = this;
      var obj = {
        project_id: project_id,
        invoice_money: this.invoice_money,
        jiesuan_remarks: this.jiesuan_remarks,
        piaomian_remarks: this.piaomian_remarks,
        template_invoice_list: this.template_invoice_list,
        express: this.express_select,
        jiesuan_file_list: this.jiesuan_file_list,
        kaipiao_file_list: this.kaipiao_xls_file_list,
        year: jiesuan_year,
        month: jiesuan_month,
        invoice_file_type: this.invoice_file_type,
        jiesuan_universal_file: this.jiesuan_universal_file_object_name,
        jiesuan_universal_batch_id: this.jiesuan_universal_batch_id,
        invocie_title: this.table_invoice_selection[0]
      };

      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否提交</p>",
        onOk: () => {
          // 检查金额
          that.jiesuan_check(obj);
        },
        onCancel: () => { },
      });
    },

    // 检测金额
    jiesuan_check(obj) {
      this.submit_loading = true

      var that = this;
      var obj2 = {
        project_id: this.project_id,
        invoice_money: this.invoice_money,
      };

      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/check_jiesuan",
        obj2,
        true
      )
        .then((res) => {
          if (res.code == 201) {
            setTimeout(() => {
              that.$Modal.confirm({
                title: "系统重复金额提示",
                content:
                  "<p>检测到提交结算总金额与上一次提交(提交时间：" +
                  res.data.create_time +
                  ")一致，是否继续提交？</p>",
                onOk: () => {
                  that.jiesuan_http(obj);
                },
                onCancel: () => { },
              });
            }, 500);
          } else {
            that.jiesuan_http(obj);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    jiesuan_http(obj) {
      var that = this;

      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 6,
            });
            that.jiesuan_success_show = true;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 6,
            });
          }
          that.submit_loading = false

        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取批量导入模板
    get_batch_template() {
      var that = this;
      var obj = {};

      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/invoice/batch_import_template",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.batch_template_list = res.data.template_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_down_template_batch(item) {
      open_new_page(item.url);
    },


    //上传统一结算表完成
    upload_universal_success(e) {
      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.jiesuan_universal_file_name = e.data.filename;
        this.jiesuan_universal_file_object_name = e.data.object_name;
        this.jiesuan_universal_file_url = e.data.url
        this.jiesuan_universal_yingfa_total_money = e.data.yingfa_money_total
        this.jiesuan_universal_shifa_total_money = e.data.shifa_money_total
        this.jiesuan_people_count = e.data.people_count
        this.jiesuan_universal_batch_id = e.data.jiesuan_batch_id

      } else {
        this.$Message.error(e.msg);
      }


    }
  },
};
</script>

<style scoped>
.rate_project_name{
  margin-right: 5px;
}

.tishi_error {
  color: red
}

.jindie_code_status_error {
  background: red;
  color: #fff;
  padding: 3px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}

.jindie_code_status_success {
  background: rgb(20, 218, 80);
  color: #fff;
  padding: 3px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}


.search_invoice_div {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.add_input_class_title {
  width: 140px;
  flex-shrink: 0;
  margin-right: 10px;
}

.add_input_class {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.universal_name1 {
  padding: 10px;
  background-color: #e9e9e9;
  border-radius: 5px;
  margin: 0px 10px 10px 0;
  cursor: pointer;
}

.universal_money {
  font-size: 13px;
  color: rgb(246, 86, 0)
}

.universal_name {
  display: flex;
  align-items: center;
}

.download_template_tongyi {
  font-size: 13px;
  cursor: pointer;
  color: #0466dd
}

.head_div2 {
  display: flex;
  align-items: center;
}

.project_name {
  padding-left: 10px;
  color: #01234c;
  font-weight: 600;
}

.head_div {
  margin: 10px 10px 10px 10px;
  height: 35px;
  display: flex;
  color: rgb(68, 68, 68);
  background: white;
  align-items: center;
  justify-content: space-between;
}

.yewu_txt {
  color: #f60a41;
}

.jiesuan_txt {
  font-size: 14px;
  color: #696969;
}

.jiesuan_select_div {
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.jiesuan_select {
  width: 80px;
  text-align: center;
  height: 40px;
  margin-right: 10px;
  line-height: 40px;
  border-radius: 5px;
  background: #0466dd;
  color: #fff;
}

.create_email {
  cursor: pointer;
  color: #0466dd;
}

.mima_qingchu {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: rgb(207, 207, 207);
  margin-bottom: 5px;
}

.batch_import_div {}

.close_jiesuan_file {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  background-color: red;
  color: #fff;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close_jiesuan_file2 {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  color: #0466dd;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view_file_div {
  display: flex;
  flex-wrap: wrap;
}

.view_file {
  font-size: 12px;
  padding: 5px 15px;
  background-color: #e9e9e9;
  color: #525252;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px 10px 10px 0;
  display: flex;
  align-items: center;
}

.upload_batch_template_div {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.template_a_herf {
  font-size: 12px;
  cursor: pointer;
  padding: 2px 5px;
  background-color: #e4effb;
  color: #333;
  margin: 0 10px 10px 0;
  border-radius: 5px;
}

.template_a {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.batch_btn_div {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.head_right {
  display: flex;
  align-items: center;
}

.jiesuan_success_button {
  margin: 0 10px;
}

.jiesuan_success_button_div {
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.jieusnasuccess_title {
  margin-top: 20px;
}

.jieusnasuccess_div {
  text-align: center;
}

.upload_zl_div {}

.kaipiaoyangli {
  font-size: 13px;
  cursor: pointer;
  color: #0466dd;
  margin-left: 10px;
}

.youji_tishi {
  display: flex;
  align-items: center;
  margin-right: 10px;
  color: #fff;
  background-color: #fc8787;
  font-size: 12px;
  padding: 0 10px;
  border-radius: 5px;
}

.record_head {
  font-size: 13px;
  padding-right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.record_head:hover {
  font-weight: 600;
  color: #000;
}

.jiesuan_button {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  margin: 10px;
  border-radius: 5px;
  bottom: 0;
}

.invocie_views {
  height: 670px;
  margin: 0 10px 10px 10px;
  overflow: hidden;
  padding: 10px;
  /* border-radius: 5px; */
  background-color: #fff;
}

.invoice_template_div {
  /* display: flex; */
  /* overflow: auto; */
  /* justify-content: center; */
  background-color: #fff;
}

.top30 {
  margin-top: 30px;
}

.select_tex_span {
  font-size: 12px;
  color: #ccc;
}

.select_tex_rate {
  font-size: 14px;
  width: 100px;
  flex-shrink: 0;
  margin-bottom: 5px;
}

.add_tex_rate_num3 {
  font-size: 10px;
  background-color: #bfbfbf;
  padding: 0px 5px;
  color: #fff;
  display: flex;
  height: 100%;
  align-items: center;
  margin-left: 10px;
}

.add_tex_rate_num2 {
  font-size: 10px;
  background-color: #7bd278;
  padding: 0px 5px;
  color: #fff;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.add_tex_rate_num {
  font-size: 10px;
  background-color: #195faf;
  padding: 0px 5px;
  color: #fff;
  height: 100%;
  display: flex;

  align-items: center;
}

.add_tex_rate_tag_div {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px dashed #ccc;
  border-bottom: 1px dashed #ccc;
  padding-top: 15px;
  padding-bottom: 10px;
}

.add_tex_rate_tag {
  padding: 0px 0px 0px 5px;
  font-size: 10px;
  height: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
  color: #333;
  border: 1px solid #e6e6e6;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #f6fbff;
}

.add_tex_rate_tag:hover {
  border: 1px solid #195faf;
}

.zhuti_title {
  width: 100px;
  flex-shrink: 0;
}

.zhuti_div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.make_invoice_main {
  display: flex;
  justify-content: center;
}

.make_invoice_div {
  width: 800px;
  height: 400px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 10px;
}

.make_invoice_title {
  padding: 5px;
  font-size: 13px;
  text-align: center;
  font-weight: 600;
  background-color: #195faf;
  color: #fff;
}

.add_invoice_button {
  display: flex;
  justify-content: flex-end;
}

.add_invoice_input {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.add_invoice_field {
  width: 120px;
  flex-shrink: 0;
}

.title_right {
  display: flex;
  align-items: center;
}

.del_invoice {
  color: red;
}

.del_invoice:hover {
  cursor: pointer;
}

.page_main {
  background-color: #efefef;
  height: 100vh;
  overflow: auto;
}

.add_invoice_title {
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  padding: 5px 10px;
  background-color: #195faf;
  color: #fff;
  border-radius: 500px;
  margin-left: 10px;
}

.add_invoice_title2 {
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 500px;
  margin-left: 10px;
}

.title {
  padding-bottom: 10px;
  color: #0e0e28;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
}

.invoice_div {
  background-color: #fff;
  padding: 15px 15px;

  margin: 0 10px 10px 10px;
}

.top10 {
  /* margin-top: 1px; */
}

/* 顶部 */

.logo_img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(255, 255, 255);
}

.head_left {
  display: flex;
  align-items: center;
}

.head_box {
  background: #f17409;
  height: 40px;
  display: flex;
  z-index: 99;
  width: 100vw;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}

/*  */
</style>
